export function validLessThan(field) {
    return (
        parseFloat(field.value) <
        parseFloat(field.getAttribute("data-less-than"))
    );
}
